import Aos from 'aos';
import { RouterProvider } from 'react-router-dom';
import './App.css';
import { routes } from './routes/routes';
// const ProfilePage = React.lazy(() => import('./ProfilePage')); 


function App() {
  Aos.init()
  return (
    <div className="App">
    <RouterProvider router={routes}></RouterProvider>
    </div>
  );
}

export default App;
